// Models

import BulkRefundModel from '../model/bulkRefund';
import BulkRefundFileViewModel from '../model/BulkRefundFileViewModel';

// Constants
import {
    FETCH_BULK_REFUND_SUCCESS,
    FETCH_BULK_REFUND_ERROR,
    HIDE_BULK_REFUND_LOADER,
    SHOW_BULK_REFUND_LOADER,
    UPLOAD_BULK_REFUND_FILE_REQUEST,
    UPLOAD_BULK_REFUND_FILE_SUCCESS,
    UPLOAD_BULK_REFUND_FILE_ERROR,
    FETCH_BULK_REFUND_BY_ID_SUCCESS,
    FETCH_BULK_REFUND_BY_ID_ERROR,
} from './bulkRefund.constants';

export const initialState = {
    tableData: [],
    staticData: {
        values: {},
        error: {},
    },
    selectedBulkUploadFile: '',
    selectedBulkUploadFileTableData: [],
    pagination: {},
    error: {},
    isLoading: false,
    uploadFile: {
        isSuccess: null,
        message: '',
        isLoading: '',
        data: {},
    },
};

export const bulRefundReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BULK_REFUND_SUCCESS: {
            const bulkRefundData = new BulkRefundModel(action.payload);
            return {
                ...state,
                ...bulkRefundData,
                error: {},
            };
        }
        case FETCH_BULK_REFUND_ERROR:
            return {
                ...initialState,
                ...action.payload,
            };
        case UPLOAD_BULK_REFUND_FILE_REQUEST:
            return {
                ...state,
                uploadFile: { isSuccess: null, error: {} },
            };
        case UPLOAD_BULK_REFUND_FILE_SUCCESS: {
            return {
                ...state,
                error: {},
                uploadFile: {
                    isSuccess: true,
                    error: null,
                    data: { ...action.payload },
                },
            };
        }
        case UPLOAD_BULK_REFUND_FILE_ERROR:
            return {
                ...state,
                uploadFile: {
                    isSuccess: false,
                    error: { ...action.payload },
                    data: {},
                },
            };

        case FETCH_BULK_REFUND_BY_ID_SUCCESS: {
            const selectedBulkUploadFileTableData = new BulkRefundFileViewModel(
                action.payload
            );
            return {
                ...state,
                ...selectedBulkUploadFileTableData,
                error: {},
            };
        }
        case FETCH_BULK_REFUND_BY_ID_ERROR:
            return {
                ...initialState,
                ...action.payload,
            };

        case SHOW_BULK_REFUND_LOADER:
            return { ...state, isLoading: true };
        case HIDE_BULK_REFUND_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
